import React from 'react';
import filter from 'lodash/filter';

import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import InboxEditor from 'src/presentation/components/pages/inboxes/InboxEditor';
import RouterLinkButton from 'src/presentation/components/RouterLinkButton';
import TablePage, { TablePageRender } from 'src/presentation/components/pages/shared/TablePage';
import useInboxes from 'src/presentation/components/pages/inboxes/hooks/useInboxes';
import { StringArrayColumn } from 'src/presentation/components/pages/shared/StringArrayColumn';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';

const filterFunc = (items, searchString) => {
  if (!searchString) {
    return items;
  }

  const nameMatch = item => item.name.toLowerCase().indexOf(searchString.trim().toLowerCase()) > -1;
  return filter(items, item => nameMatch(item));
};

const description = (
  <div>
    To learn more about Inboxes, visit{' '}
    <ExternalLink data-aid="help-docs-link" to="https://help.gladly.com/docs/whats-an-inbox" />.
  </div>
);

const columnConfig = [
  { attr: 'name', label: 'Name', customColumnStyle: () => ({ width: '300px' }) },
  {
    attr: 'slaString',
    label: 'SLA',
    customColumnStyle: () => ({ minWidth: '150px', textAlign: 'right' }),
    customStyle: () => ({ textAlign: 'right' }),
  },
  {
    attr: '',
    label: 'Number of agents',
    customRenderer: ({ agentNames }) => <>{agentNames.length}</>,
    customColumnStyle: () => ({ width: '200px', textAlign: 'right' }),
    customStyle: () => ({ textAlign: 'right' }),
  },
  {
    attr: 'agentNames',
    label: 'Members',
    customRenderer: item => <StringArrayColumn attr="agentNames" item={item} />,
    customColumnStyle: () => ({ width: '450px' }),
  },
  {
    attr: 'disabled',
    label: 'Status',
    customRenderer: ({ disabled }) => (disabled ? 'Deactivated' : ''),
    customColumnStyle: () => ({ width: '120px' }),
  },
];

const Inboxes: TablePageRender = ({ root }): JSX.Element => {
  const { values, errors, loadingState, resetErrors } = useInboxes();

  const actions = (
    <RouterLinkButton data-aid="create-inbox-action-button" to={`${root}/new`}>
      Create Inbox
    </RouterLinkButton>
  );

  return (
    <TablePage
      actions={actions}
      columnConfig={columnConfig}
      data-aid="admin-inboxes-page"
      description={description}
      editor={InboxEditor}
      errors={errors}
      filterFunc={filterFunc}
      isLoading={isLoadingStatus(loadingState)}
      items={values}
      name="Inboxes"
      resetErrors={resetErrors}
      root={root}
    />
  );
};

export default Inboxes;
